import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-certificated-filter',
  templateUrl: './certificated-filter.component.html',
  styleUrls: ['./certificated-filter.component.scss']
})
export class CertificatedFilterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
